<template>
  <div id="rewards">
    
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <h1>DamnN Bank </h1>
      </v-row>
    </v-container>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="8">
          <v-card color="blue" dark>
            <v-alert text type="success" :value="showSuccess" dismissible>Your payment was successful. Your balance is now ${{ (balance/100).toFixed(2) }}</v-alert>
            <v-card-text>
              <v-row align="center">
                <v-col cols="5">
                  <v-card-title class="headline text-start">Balance</v-card-title>
                  <v-card-subtitle class="text-start">Your current balance</v-card-subtitle>
                </v-col>
                <v-col class="display-2 text-end" cols="7">${{ balance }}</v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="8">
          <v-card dark>
            <v-card-text>
              <v-row align="center">
                <v-col cols="6">
                  <v-card-title class="headline text-start mb-2">Top Up</v-card-title>
                  <v-card-subtitle class="text-start">Select a top up amount and payment method</v-card-subtitle>
                </v-col>
                <v-col class="display-2 text-center" cols="6">
                  <v-form @submit.prevent="validate" ref="form" lazy-validation>
                    <v-select
                      :items="paymentAmounts"
                      v-model="paymentAmount"
                      label="Amount"
                      class="mb-2"
                    ></v-select>
                    <!--<card
                      ref="cardElem"
                      class="stripe-card mb-2"
                      :class="{ complete }"
                      :stripe="apiKey"
                      :options="stripeOptions"
                      @change="complete = $event.complete"
                      dark
                    ></card>  -->
                    <div class="red--text text--darken-1 text-caption">{{stripeErr}}</div>
                    <v-btn  color=""  
                      class="mt-4"  id="paypal-button"
                      :disabled="topupDisabled"
                    ></v-btn> 
                   
                  </v-form>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog v-model="modal" max-width="320">
      <v-card>
        <v-card-title class="headline" >
       <h3 class="msggreen" >   Payment Successfull! </h3>
          </v-card-title>
        <!-- <v-card-text>{{ purchaseMessage }}</v-card-text> -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="modal = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
/*
import {
 // Card,
  //createToken,
  //createPaymentMethod
} from "vue-stripe-elements-plus";
*/
//import Vue from "vue";
//import axios from "axios";
//import VueAxios from "vue-axios";

import axios from 'axios'
import VueAxios from 'vue-axios'
import Vue from 'vue'
import {loadScript} from "vue-plugin-load-script";

//Vue.use(loadScript);
Vue.use(VueAxios, axios)

axios.defaults.baseURL = process.env.VUE_APP_BASEAPI;
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
var damnnUrl = process.env.VUE_APP_BASEAPI;

export default {
  name: "topup",
  components: { 
  //Card  //New Change 

  },
  data() {
    return {
      showSuccess: false,
      topupDisabled: false,
      email: "",
      cardElem: null,
      stripeErr: "",
      stripeOptions: {
        hidePostalCode: true,
        style: {
          base: {
            color: "#fff",
            fontSize: "16px",
            fontFamily: '"Roboto", sans-serif'
          }
        }
      },
      complete: false,
      error: false,
      modal: false,
      paymentAmounts: [],
      paymentAmount: "",
      balance: 0,
      apiKey: process.env.VUE_APP_STRIPE_API_KEY
    };
  },
  mounted() {
    this.getUserEmail();
    this.getPaymentAmounts();
    this.getBalance();

    this.pay();
  },
  computed: {},
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        if (this.paymentAmount === "") {
          this.stripeErr = "Please select a top up amount";
          return false;
        }
        this.stripeErr = "";
        this.topupDisabled = true;
        
      }
    },
    pay() {
var mythis = this;
         //********** PAYPAL CODE ****************
           loadScript("https://www.paypalobjects.com/api/checkout.js").then(() => 
             {
             
               window.paypal.Button.render({
                 env: 'sandbox',
                 client: {
                  //sandbox: 'AYSQ-B3COkyHGMWTWkyrfWtl8tPdxEBI0GejO4tfbmPX3JbT_zv-lshM3EmQXiHoDzvd964pQGz1Sjlo',
                 production: 'AUxJGrr53OY24x1KlUwTHy4rkPvhW_Srkli1rmnRjfHyDTa00ZEgphHVJ0wkdVnWxA43KeMrPCVS39re'
                 },
                 locale: 'en_US',
                 style: {
                          size: 'small',
                          color: 'gold',
                          shape: 'pill',
                          tagline: 'false'
                        },
                 commit: true,

                 payment: function(resolve, reject) {
                   console.log(resolve, reject);
                  let returnUrl = "https://admin.sporttrade.online/faq";
                  let amount = mythis.paymentAmount /100;

                  //********* Check Validate ***************

                     if (mythis.paymentAmount === "") {
                        mythis.stripeErr = "Please select a top up amount";
                          return false;
                       }else{
                         mythis.stripeErr = "";
                       }
                  //****************************************
                   return new Promise((resolve, reject) => {
                  Vue.axios.post(damnnUrl+'create-payment-centeralize', {
                    return_url: returnUrl,
                    amount:amount,
                    app_type:"quizstar"
                }, {
                        headers: { 'Authorization': 'Bearer ' + localStorage.getItem('damn_token') }
                    })
                    .then(res => {
                      //console.log(res.data);
                        localStorage.setItem('reference_id', res.data.paypal_intent_id.reference_id);
                        resolve(res.data.paypal_intent_id.paypal_intent_id)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
            },
            
            onAuthorize: function(data) {
              
                  return new Promise((resolve, reject) => {
                Vue.axios.post(damnnUrl+'execute-payment-centralize',  {
                    payer_id: data.payerID,
                    payment_id: data.paymentID,
                    reference_id:localStorage.getItem('reference_id'),
                    description:"Add balance  into wallet"
                }, {
                        headers: { 'Authorization': 'Bearer ' +  localStorage.getItem('damn_token') }
                    })
                    .then(res => {
                      localStorage.removeItem('reference_id');
                      localStorage.removeItem('price');
                      //mythis.closedeposit();
                     // mythis.$store.dispatch('retrieveInbankKelBalance');
                      mythis.getBalance(); 
                      //mythis.$store.dispatch("retrieveInbankKelBalance");
                      mythis.modal = true;
                        resolve(res)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
            }
          }, '#paypal-button'); 


             });
         //***********END PAYPAL CODE *************
   
    },
    getUserEmail() {
      this.$store.dispatch("retrieveUserDetails").then(() => {
        this.email = this.$store.getters.email;
      });
    },
    getPaymentAmounts() {
      this.$store.dispatch("retrievePaymentAmounts").then(() => {
        this.paymentAmounts = this.$store.getters.paymentAmounts;
      });
    },
    getTimezone() {
      this.timezone = this.$moment.tz.guess();
    },
    getBalance() {
      //this.$store.dispatch("retrieveBalance").then(() => {
       // this.balance = this.$store.getters.balance;
      //});

      this.$store.dispatch("retrieveInbankKelBalance").then(() => {
            this.balance = this.$store.getters.showamount;
           });

    },
    amountChanged() {
      if (this.paymentAmount === 0) {
        this.error = true;
        return;
      } else {
        this.error = false;
      }
    }
  }
};
</script>

<style scoped>
.stripe-card {
  /* width: 300px; */
  border-bottom: 1px solid grey;
}

.InputElement.Input {
  color: white !important;
}
#paypal-button{z-index: 0 !important;margin-left: -28px; background: none !important;}
.msggreen{color:#4caf50;}
</style>